import { DialogService } from '@caslink/common-client/ng-app/dialog-service/dialog.service';
import { AppRootScope } from '../typings/AppRootScope';
import { MessageType } from '../typings/MessageType';

/*
 * angular-material's layout-padding directive is a hot, steaming pile of garbage that makes everything more difficult for everyone
 * by applying padding to child elements as well as the element that is it applied to.
 * Give developers a warning if they try to use it.
 */

export class LayoutPaddingDirective implements angular.IDirective {
    public static $name: string = 'layoutPadding';
    public priority: number = 1;
    public restrict: string = 'A';
    public terminal: boolean = true;

    public link =
        (scope: AppRootScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
            this.dialogService.showMessageDialog(
                'Warning',
                'Please use the .cl-layout-padding class instead of the angular-material layout-padding directive',
                MessageType.Warning
            );
        }

    constructor(
        private dialogService: DialogService
    ) {
    }

    public static Factory() {
        let directive = (dialogService) => {
            return new LayoutPaddingDirective(dialogService);
        };

        directive['$inject'] = ['clDialogService'];

        return directive;
    }
}
